// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-tooltip__popper{width:200px!important;line-height:24px!important}.floor-sale-container .title{padding:10px;margin-top:20px}", ""]);
// Exports
module.exports = exports;
